<mat-card>
  <mat-card-content>
    <mat-card-title>Fluxo de Caixa</mat-card-title>

    <div class="chart-container">
      <div class="chart-wrapper" *ngIf="cashFlow.length > 0">
        <ngx-charts-bar-vertical-2d
          [view]="view"
          [scheme]="colorScheme"
          [results]="chartData"
          [gradient]="gradient"
          [xAxis]="showXAxis"
          [yAxis]="showYAxis"
          [legend]="showLegend"
          [legendPosition]="legendPosition"
          [showXAxisLabel]="showXAxisLabel"
          [showYAxisLabel]="showYAxisLabel"
          [yAxisTickFormatting]="yAxisTickFormatting"
          [barPadding]="80"
          [groupPadding]="16">

          <ng-template #tooltipTemplate let-model="model">
            <div class="custom-tooltip">
              <span
                  style="display: block;
                  font-size: 12px;
                  color: #cfcfcf;">
                {{ model.name }}
              </span>
              <span
                  style="display:
                  block; font-size: 14px;
                  font-weight: bold;">
                  {{ model.value | currency: 'BRL' }}
              </span>
            </div>
          </ng-template>
        </ngx-charts-bar-vertical-2d>
      </div>

      <div *ngIf="cashFlow.length === 0" class="no-data-overlay">
        <mat-icon>show_chart</mat-icon>
        <p>Não há dados de fluxo de caixa</p>
      </div>
    </div>
  </mat-card-content>
</mat-card>
